export default "__VITE_ASSET__BaLweLvN__"